import DropShopSearch from '../../../services/dropShopSearch'

const SET_DROP_SHOPS = 'SET_DROP_SHOPS'
const SET_COORDS = 'SET_COORDS'
const SET_PREFFERED_DROP_SHOP = 'SET_PREFFERED_DROP_SHOP'
const SET_SELECTED_DROP_SHOP = 'SET_SELECTED_DROP_SHOP'
const SET_MARKERS = 'SET_MARKERS'
const SET_DISTANCE = 'SET_DISTANCE'
const SET_ADDRESS = 'SET_ADDRESS'
const SET_COUNTRY = 'SET_COUNTRY'

const state = {
  address: '',
  country: '',
  distance: 10000,
  dropShops: [],
  lastSearchParams: {},
  lat: undefined,
  lng: undefined,
  markers: undefined,
  preferedDropShop: undefined,
  selectedDropShop: undefined,
}

const getters = {
  selectedDropShop(state) {
    if(state.selectedDropShop) {
      return state.selectedDropShop
    }

    return state.dropShops[0]
  }
}

const actions = {
  searchDropShops({state, commit}) {
    const lSearchParams = state.lastSearchParams;

    /* Only trigger a search if params change */
    if (lSearchParams['address'] !== state.address ||
        lSearchParams['country'] !== state.country ||
        lSearchParams['distance'] !== state.distance) {
          const nSearchParams = {
          address: state.address,
          country: state.country,
          distance: state.distance,
        };
        state.lastSearchParams = nSearchParams;
      
        return DropShopSearch.searchDropShops(state.address, state.distance, state.country)
          .then(data => {
            commit(SET_DROP_SHOPS, (data.dropShops.length > 0 ? data.dropShops : false))
            commit(SET_COORDS, { lat: data.lat, lng: data.lng })
            commit(SET_PREFFERED_DROP_SHOP, data.preferedDropShop)
            commit(SET_MARKERS, data.markers)
          })
          .catch(err => {
            commit(SET_DROP_SHOPS, false)
            commit(SET_COORDS, { lat: undefined, lng: undefined })
            commit(SET_PREFFERED_DROP_SHOP, undefined)
            commit(SET_MARKERS, undefined)
            throw err
          });
      }
  },

  selectDropShopById({state, commit}, dropShopId) {
    return commit(
      'SET_SELECTED_DROP_SHOP', 
      state.dropShops.filter(item => item.id === dropShopId).shift()
    )
  },
}

const mutations = {
  [SET_DROP_SHOPS](state, value) {
    state.dropShops = value
  },

  [SET_COORDS](state, { lat, lng }) {
    state.lat = lat
    state.lng = lng
  },

  [SET_PREFFERED_DROP_SHOP](state, value) {
    state.preferedDropShop = value
  },

  [SET_SELECTED_DROP_SHOP](state, value) {
    state.selectedDropShop = value
  },

  [SET_MARKERS](state, value) {
    state.markers = value
  },

  [SET_ADDRESS](state, value) {
    state.address = value
  },

  [SET_DISTANCE](state, value) {
    state.distance = value
  },

  [SET_COUNTRY](state, value) {
    state.country = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./client/store/modules/dropShops/index.js